(ns app.front.view.property.attribute
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]))

(defn attribute-tags [attributes]
  (let [by-style (group-by :legacy-property-attribute/style attributes)]
    [:<>
     (futil/for-frag [attr (:property-attribute.style/default by-style)]
       [:p.mb-1.pb-0 (:legacy-property-attribute/value attr)])
     (futil/for-frag [attr (:property-attribute.style/tag by-style)]
       [ui/tag {:color      :night-sky
                :type       :round
                :class-name "uppercase first:ml-0"} (:legacy-property-attribute/value attr)])]))

(defn attribute-tags-from-property [{:property/keys [legacy-attributes]}]
  (attribute-tags legacy-attributes))
